import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import 'zone.js';
//import '@dsy/enelx';
//import '@dsy/enel';
//for the dates 
import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeES from '@angular/common/locales/es'
import localeJA from '@angular/common/locales/ja'
import localePL from '@angular/common/locales/pl'
import localePT from '@angular/common/locales/pt'
import localeZH from '@angular/common/locales/zh'

registerLocaleData(localeEn);
registerLocaleData(localeES);
registerLocaleData(localeJA);
registerLocaleData(localePL);
registerLocaleData(localePT);
registerLocaleData(localeZH);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));